export function editionRoute(path) {
  let match = path.match(/^\/research\/editions\/(\d{4}-\d{2}-\d{2})\/(morning|evening|event|legacy)\/r([1-9]\d*)$/);
  if (match) return {date: match[1], endpoint: `/revisions/${match[1]}:${match[2]}:r${match[3]}`};
  match = path.match(/^\/research\/editions\/(\d{4}-\d{2}-\d{2})\/original\/(morning|evening|event|legacy)$/);
  if (match) return {date: match[1], endpoint: `/original/${match[1]}/${match[2]}`, original: true};
  match = path.match(/^\/research\/editions\/id\/([^/]+)$/);
  if (match) { try { const id = decodeURIComponent(match[1]); if (/^\d{4}-\d{2}-\d{2}(?::(?:morning|evening|event|legacy)(?::r[1-9]\d*)?)?$/.test(id)) return {date: id.slice(0,10), endpoint: `/revisions/${encodeURIComponent(id)}`}; } catch {} }
  match = path.match(/^\/research\/editions\/(\d{4}-\d{2}-\d{2})(?:\/(morning|evening|event))?$/);
  return match ? {date: match[1], endpoint: `/${match[1]}${match[2] ? '/' + match[2] : ''}`} : null;
}
export function editionLink(edition) {
  const id = edition.editionId;
  const match = id?.match(/^(\d{4}-\d{2}-\d{2}):(morning|evening|event|legacy):r([1-9]\d*)$/);
  if (match) return `/research/editions/${match[1]}/${match[2]}/r${match[3]}`;
  return id ? `/research/editions/id/${encodeURIComponent(id)}` : `/research/editions/${edition.date}`;
}
export function revisionInfo(edition) {
  const [byline, ...correction] = String(edition.byline || '').split(/\s*·\s*Correction:\s*/i);
  return {byline, note: edition.revision?.note || correction.join(' · '), number: edition.revision?.number || 1};
}
